import React, { useState } from 'react';
import { NodeViewWrapper, NodeViewProps } from '@tiptap/react';
import katex from 'katex';
import 'katex/dist/katex.min.css';

function decodeHtmlEntities(str: string) {
  const txt = document.createElement('textarea');
  txt.innerHTML = str;
  return txt.value;
}

const MathBlockNodeView: React.FC<NodeViewProps> = ({
  node,
  updateAttributes,
}) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isCommentEditing, setIsCommentEditing] = useState(false);
  const rawFormula = node?.attrs?.formula || '';
  const rawComment = node?.attrs?.comment || '';

  // Check if the formula is already HTML (contains HTML tags)
  const isHtmlFormula = rawFormula.includes('<') && rawFormula.includes('>');

  let html = '';
  let latexForEditing = '';

  if (isHtmlFormula) {
    // If it's already HTML, use it directly
    html = rawFormula;
    latexForEditing = rawFormula; // For HTML formulas, edit as-is
  } else {
    // If it's LaTeX, render it with KaTeX
    const formula = decodeHtmlEntities(rawFormula);
    latexForEditing = formula;
    try {
      html = katex.renderToString(formula, {
        throwOnError: false,
        displayMode: true,
      });
    } catch (error) {
      html = `<span style="color:red;">Invalid formula</span>`;
    }
  }

  const handleFormulaClick = () => {
    setIsModalOpen(true);
  };

  const handleFormulaSave = (latex: string) => {
    if (updateAttributes) {
      updateAttributes({
        formula: latex,
        comment: rawComment,
      });
    }
    setIsModalOpen(false);
  };

  const handleCommentSave = (e: React.FocusEvent<HTMLDivElement>) => {
    const newComment = e.currentTarget.textContent || '';
    if (updateAttributes) {
      updateAttributes({
        formula: rawFormula,
        comment: newComment,
      });
    }
    setIsCommentEditing(false);
  };

  const handleCommentKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
    if (e.key === 'Enter') {
      e.preventDefault();
      e.currentTarget.blur();
    } else if (e.key === 'Escape') {
      e.preventDefault();
      e.currentTarget.textContent = rawComment;
      e.currentTarget.blur();
    }
  };

  return (
    <>
      <NodeViewWrapper
        as="div"
        data-type="math-block"
        className="math-block p-4 my-4 border border-gray-200 rounded-lg hover:bg-gray-50 transition-colors"
      >
        <div className="flex flex-col items-center gap-2">
          {/* Formula */}
          <div
            dangerouslySetInnerHTML={{ __html: html }}
            onClick={handleFormulaClick}
            className="cursor-pointer hover:bg-gray-100 rounded p-2 transition-colors"
            title="Click to edit formula"
          />

          {/* Comment */}
          {/* <div
            contentEditable
            suppressContentEditableWarning
            onBlur={handleCommentSave}
            onKeyDown={handleCommentKeyDown}
            onFocus={() => setIsCommentEditing(true)}
            className="text-sm text-gray-600 italic cursor-text hover:bg-gray-100 rounded px-2 py-1 min-w-[100px] text-center focus:outline-none focus:ring-2 focus:ring-blue-300"
            title="Click to edit comment"
            style={{ minHeight: '1.5em' }}
          >
            {rawComment || 'Click to add comment'}
          </div> */}
        </div>
      </NodeViewWrapper>
    </>
  );
};

export default MathBlockNodeView;
